import { Button } from '@leroy-merlin-br/backyard-react-ui'

import { Icon } from 'lmcv/components/Icon'

import { Step } from '../../components/Step'
import { Client } from '../../components/Client'
import * as S from './styled'

const ClientsMobile = ({
  currentStep,
  customers,
  onSelectCustomer,
  customerSelected,
  onClose,
  onClick
}) => {
  return (
    <Step step={2} currentStep={currentStep}>
      <S.Overlay />
      <S.Container>
        <S.ModalClose onClick={onClose}>
          <Icon name="close_tiny" />
        </S.ModalClose>

        <S.Title>Selecione um cliente para compartilhar</S.Title>

        <form>
          <ul>
            {customers.length &&
              customers.map((item, index) => (
                <S.Item key={index}>
                  <S.RadioButtonLabel>
                    <S.RadioButton
                      type="radio"
                      name="rdClient"
                      onClick={() => onSelectCustomer(item)}
                    />
                    <Client
                      name={item.customerName}
                      projectName={item.projectName}
                    />
                  </S.RadioButtonLabel>
                </S.Item>
              ))}
          </ul>
        </form>

        <S.ContainerFooter>
          <Button
            color="green"
            isDisabled={!customerSelected}
            onClick={onClick}
          >
            Compartilhar
          </Button>
        </S.ContainerFooter>
      </S.Container>
    </Step>
  )
}

export default ClientsMobile
